import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';
const bem = new BEMHelper('EmptyList');

const EmptyList = (props) => {
    const { className, icon, title, details, children, variant } = props;

    if (!title && !details) {
        return null;
    }

    return (
        <div className={bem(null, null, className)}>
            <div className={bem('container', variant)}>
                {icon}
                {title && <h2 className={bem('title', variant)}>{title}</h2>}
                {details && <p className={bem('details', variant)}>{details}</p>}
                {children}
            </div>
        </div>
    );
};

EmptyList.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.node,
    title: PropTypes.string,
    details: PropTypes.string,
    children: PropTypes.node,
    variant: PropTypes.string,
};

export default EmptyList;
